import api from '@/modules/attendance/api'
const historyStore = {
  namespaced: true,
  state: () => ({
    history: [],
    modules: []
  }),
  mutations: {
    setHistory(state, payload) {
      state.history = payload
    },
    setModules(state, payload) {
      state.modules = payload
    }
  },
  getters: {
    getHistory(state) {
      return state.history
    },
    getModules(state) {
      return state.modules
    }
  },
  actions: {
    setModules(context, payload) {
      context.commit('setModules', payload)
    },
    async setPatientHistory(context, payload) {
      try {
        const response = await api.getPatientAttendancesGroupedByDate(payload)
        context.commit('setHistory', response.data)
      } catch {
        // Histórico na consulta 2.0 é carregado principalmente em PatientHistorySidebar.getHistory
      }
    }
  }
}

export default historyStore
